<div
	*ngIf="isLoading"
	class="table-loading-overlay"
	role="status"
	aria-label="Cargando"
>
	<mat-spinner [diameter]="50"></mat-spinner>
</div>
